var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUmbrella = function SvgUmbrella(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 117,
    viewBox: "0 0 232 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.32 87.9441C185.836 85.807 183.418 84.5467 180.836 84.5467H158.418L151.386 74.2449C149.902 72.053 147.429 70.7927 144.792 70.7927H111.276L107.979 58.4634C107.759 57.6415 106.935 57.1483 106.111 57.3675L101.605 58.573C100.781 58.7922 100.287 59.6142 100.506 60.4361L108.583 90.4647L100.396 107.178L107.32 110.575L116.111 92.4922C116.221 92.2182 116.331 91.9442 116.386 91.6702H180.781C181.001 91.6702 181.221 91.7798 181.386 91.999L196.88 114.685L202.759 110.685L187.32 87.9441ZM144.792 75.0668C145.946 75.0668 147.045 75.6696 147.704 76.6012L153.034 84.4371H114.957L112.429 75.0121H144.792V75.0668Z",
    fill: "url(#paint0_linear_36676_7041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.153 116H12.4277C28.8563 106.246 50.7794 99.013 72.8124 99.3418C99.131 99.7254 124.406 105.808 131.274 109.15C150.12 108 174.076 103.068 186.604 103.452C197.263 103.835 212.757 106.685 222.153 116Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231 116H222.154H12.4286H1",
    stroke: "#D5DAE8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6254 105.589C83.4715 105.589 82.4276 104.767 82.2078 103.616L62.7573 2.95432C62.4825 1.6392 63.3617 0.32408 64.7353 0.0500959C66.054 -0.223888 67.3726 0.65286 67.6474 2.02278L87.0979 102.63C87.3726 103.945 86.4935 105.26 85.1199 105.534C84.9001 105.589 84.7902 105.589 84.6254 105.589Z",
    fill: "#ADB6C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6035 53.9154C51.6585 53.5866 51.7684 53.3127 51.8782 52.9839C51.9332 53.4771 51.9332 53.9702 51.9881 54.4634C51.8782 54.2442 51.7134 54.0798 51.6035 53.9154Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2862 45.3669C95.2312 45.4217 95.2312 45.5313 95.2312 45.5861C95.1763 45.4217 95.1214 45.2573 95.0664 45.0381C95.1214 45.1477 95.2312 45.2573 95.2862 45.3669Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.587 46.9442C181.087 46.9442 189.598 38.4557 189.598 27.9846C189.598 17.5134 181.087 9.0249 170.587 9.0249C160.088 9.0249 151.576 17.5134 151.576 27.9846C151.576 38.4557 160.088 46.9442 170.587 46.9442Z",
    fill: "#FFE2A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.582 111.123C45.7249 107.835 50.1754 108.603 51.9886 109.26",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8027 107.726C78.3082 104.931 84.1874 107.068 84.6269 109.205",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.373 113.041C93.1423 111.945 94.9005 111.123 96.0544 111.89",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.803 112.329C168.363 110.849 168.583 111.781 169.737 112.329",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.242 111.123C179.737 110.246 182.154 110.63 182.154 110.63",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 30.1883C125.45 27.8868 120.065 27.0101 114.571 28.0512C105.065 29.8047 97.8127 36.7091 95.2852 45.367C95.2303 45.4218 95.2303 45.5314 95.2303 45.5862C95.1753 45.4218 95.1204 45.2574 95.0654 45.0382C89.5709 38.079 80.4501 34.2433 71.0545 35.9968C61.6588 37.6955 54.516 44.4902 51.8786 52.9837C51.9336 53.4769 51.9336 53.9701 51.9885 54.4632C51.8786 54.2989 51.7138 54.0797 51.6039 53.9153C46.1643 46.4081 36.7687 42.2984 27.0435 44.0519C21.9336 44.9834 17.4281 47.4493 14.0215 50.8467C19.9556 27.1197 39.2962 7.77644 65.0105 3.11872C90.9446 -1.6486 116.109 9.80392 130.065 30.1883Z",
    fill: "url(#paint1_linear_36676_7041)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0651 45.0384C89.5706 38.0793 80.4497 34.2435 71.0541 35.997C61.6585 37.6957 54.5156 44.4905 51.8783 52.984C49.6805 25.9692 54.7904 4.98202 65.0651 3.11894C75.2849 1.25585 87.4827 19.0648 95.0651 45.0384Z",
    fill: "#EAEEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36676_7041",
    x1: 151.586,
    y1: 59.3084,
    x2: 151.586,
    y2: 91.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BDCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36676_7041",
    x1: 14.0215,
    y1: 2.04346,
    x2: 116.42,
    y2: 70.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D60F3"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUmbrella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/umbrella.fbd6b989.svg";
export { ForwardRef as ReactComponent };